var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.$t(`ip_subnet_scan_status.${_vm.status}`)))])
}
var staticRenderFns = []

export { render, staticRenderFns }